import IconTypeFilter from 'filters/TypeFilter/IconTypeFilter';
import PillTypeFilter from 'filters/TypeFilter/PillTypeFilter';
import { FilterType } from 'rangeConfig/@types';
import HingedDoorIcon from 'rangeConfig/Icons/HingedDoor.svg?react';
import SlidingDoorIcon from 'rangeConfig/Icons/SlidingDoor.svg?react';
import { ProductType } from '@inter-ikea-storageone/range';

export const doorsTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'hingedDoor',
      name: 'storageone.filterOptionHingedDoor',
      icon: HingedDoorIcon,
      types: [ProductType.PLATSA_HINGE_DOOR_ASM]
    },
    {
      id: 'slidingDoor',
      name: 'storageone.filterOptionSlidingDoor',
      icon: SlidingDoorIcon,
      types: [ProductType.PLATSA_SLIDING_DOOR_ASM]
    }
  ]
};

export const frameTypeFilter = {
  component: PillTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'platsa-frame-type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'frame',
      name: 'storageone.filterOptionFrames',
      types: [ProductType.PLATSA_FRAME]
    },
    {
      id: 'open-frame',
      name: 'storageone.filterOptionOpenFrames',
      types: [
        ProductType.PLATSA_OPEN_FRAME_SHELVES,
        ProductType.PLATSA_OPEN_FRAME_HANGING,
        ProductType.PLATSA_OPEN_FRAME_SHOES
      ]
    }
  ]
};
